<template>
  <b-modal
      ref="add-bonus-manual-modal"
      size="lg"
      :title="$t('bonus.modal.add_bonus_manual')"
  >
    <b-form>
      <b-form-group id="input-group-1" :label="$t('form.label.bonus_amount')" label-for="input-1">
        <b-form-input
            id="input-1"
            v-model="form.amount"
            @keypress="isRestricted($event)"
            :state="!$v.form.amount.$dirty ? null :(!$v.form.amount.$error)"
            :placeholder="$t('form.placeholder.enter_bonus_amount')"
            required
        ></b-form-input>
        <p v-if="$v.form.amount.$dirty && !$v.form.amount.required" class="text-danger">{{ $t('errors.required') }}</p>
      </b-form-group>
      <b-form-group
          :label="$t('form.label.bonus_list')"
          label-for="bonus"
      >
        <b-form-select
            id="bonus"
            v-model="form.bonus"
            :options="bonuses"
            @change="$v.form.bonus.$model = $event"
            :placeholder="$t('form.placeholder.choose_bonus')"
            :state="!$v.form.bonus.$dirty ? null :(!$v.form.bonus.$error)"
            value-field="id"
            text-field="name"
        ></b-form-select>
        <p v-if="$v.form.bonus.$dirty && !$v.form.bonus.required" class="text-danger">
          {{ $t('errors.required') }}
        </p>
      </b-form-group>
    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <div class="buttons float-right">
          <b-button type="button" variant="secondary" class="mr-1" @click="hideModal()">{{$t('btn.cancel')}}</b-button>
          <b-button variant="primary" :disabled="busy" @click="submit()">
            <div v-if="busy">
              <b-spinner small type="grow"></b-spinner>
              {{ $t('btn.state.saving') }}
            </div>
            <div v-else>
              {{ $t('btn.save') }}
            </div>
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import alertify from "alertifyjs";

export default {
  props: {
    walletId: String,
    bonuses: Array
  },
  data() {
    return {
      busy: false,
      groups: [],
      serverError: null,
      form: {
        amount: null,
        bonus: null
      },
    }
  },
  validations: {
    form: {
      amount: {
        required
      },
      bonus: {
        required
      }
    }
  },
  mounted() {
    this.openModal();
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

        const payload = {
          bonusDefinitionId: this.form.bonus,
          bonusAmount: this.form.amount,
          walletId: this.walletId
        }

        this.$store.dispatch('players/setManualBonus', payload)
        .then(
            () => {
              setTimeout(() => this.$parent.getPlayer(),2000);
              this.hideModal();
              alertify.success('Manual bonus success.');
            }
        ).catch( err => {
          this.serverError = err.response.data.parameters;
        })
      }
    },
    openModal() {
      this.$refs['add-bonus-manual-modal'].show();
    },
    hideModal() {
      this.$refs['add-bonus-manual-modal'].hide();
    },
    isRestricted: function(e) {
      e = (e) ? e : window.event;
      let charCode = (e.which) ? e.which : e.keyCode;
      // 0-9 and . are allowed
      if (charCode !== 44 && charCode !== 46 && (charCode < 48 || charCode > 57)) {
        e.preventDefault();
      } else {
        return true;
      }
    }
  }
}
</script>
